import { FC } from 'react';

import CustomerMap from '../../components/table/customerMap/CustomerMap';

import styles from './mapOutlets.module.scss';

const MapOutlets: FC = () => {
	return (
		<div className={styles.vacancyCreateWrapper}>
			<CustomerMap/>
		</div>
	);
};

export default MapOutlets;
